const SCANNER_OPTION_ENABLED = !!document.querySelector(
  '#sectionScannerOptions'
);

const totalPriceDisplay = document.getElementById('totalPrice');

function validateForm() {
  const errors = {};

  const filmQuantityInputs = document.querySelectorAll(
    'input[name="quantity[]"]'
  );
  const totalQuantity = [...filmQuantityInputs].reduce(
    (sum, input) => sum + (parseFloat(input.value) || 0),
    0
  );
  if (totalQuantity <= 0) {
    errors['error-quantity'] = 'Enter a quantity for at least one film type.';
  }

  const scanDropdown = document.getElementById('scanDropdown');
  if (scanDropdown.value === 'none') {
    errors['error-scan'] = 'Select a scan type.';
  }

  const negativesDropdown = document.getElementById('negativesDropdown');
  if (negativesDropdown.value === 'none') {
    errors['error-negatives'] = 'Choose what to do with your negatives.';
  }

  return { valid: Object.keys(errors).length === 0, errors };
}

function renderErrors(errors, { onlyExisting = false } = {}) {
  ['error-quantity', 'error-scan', 'error-negatives'].forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const message = errors[id] || '';
    if (onlyExisting && !el.textContent) return;
    el.textContent = message;
  });
}

function focusFirstInvalid(errors) {
  if (errors['error-quantity']) {
    document.querySelector('input[name="quantity[]"]')?.focus();
  } else if (errors['error-scan']) {
    document.getElementById('scanDropdown')?.focus();
  } else if (errors['error-negatives']) {
    document.getElementById('negativesDropdown')?.focus();
  }
}

document.querySelector('.custom-form').addEventListener('input', function () {
  let total = 0.0;

  // Get all the quantity inputs into an array
  let filmQuantityInputs = document.querySelectorAll(
    'input[name="quantity[]"]'
  );
  var totalQuantity = 0;

  // Loop through each quantity input to calculate the total price
  filmQuantityInputs.forEach((input, index) => {
    const quantity = parseFloat(input.value) || 0;
    totalQuantity += quantity;
    const price = parseFloat(input.getAttribute('data-price')) / 100;
    total += price * quantity;
  });

  // New code for adding the selected scan type price to the total
  const scanDropdown = document.getElementById('scanDropdown');
  const selectedScanOption = scanDropdown.selectedOptions[0];

  if (
    selectedScanOption &&
    selectedScanOption.value !== 'none' &&
    selectedScanOption.value !== 'process-only'
  ) {
    const selectedVariant = document.querySelector(
      'input[name="selectedVariant"]:checked'
    );
    let scanPrice =
      parseFloat(selectedScanOption.getAttribute('data-price')) / 100;

    if (selectedVariant) {
      // Multiple variants - use selected variant price
      scanPrice = parseFloat(selectedVariant.getAttribute('data-price')) / 100;
    } else {
      // Single variant - get first variant price from data
      const variantsData = selectedScanOption.getAttribute('data-variants');
      if (variantsData) {
        try {
          const variants = JSON.parse(variantsData);
          if (variants.length > 0) {
            scanPrice = parseFloat(variants[0].price) / 100;
          }
        } catch (e) {
          console.error('Error parsing variants for pricing:', e);
        }
      }
    }

    const scanQuantity = totalQuantity; // one scan per film
    total += scanPrice * scanQuantity;
  }

  // Code for adding prints price to total
  const printsCheckbox = document.querySelector('input[name="prints_id"]');
  if (printsCheckbox.checked) {
    const printsPrice =
      parseFloat(printsCheckbox.getAttribute('data-price')) / 100;
    const printsQuantity = totalQuantity; // one print per film
    total += printsPrice * printsQuantity;
  }

  // Code for adding TIFF upsell price to total
  const tiffCheckbox = document.querySelector('input[name="tiff_id"]');
  if (tiffCheckbox && tiffCheckbox.checked) {
    const tiffPrice = parseFloat(tiffCheckbox.getAttribute('data-price')) / 100;
    const tiffQuantity = totalQuantity; // TIFF per film quantity
    total += tiffPrice * tiffQuantity;
  }

  // add negatives
  const negativesDropdown = document.getElementById('negativesDropdown');
  const selectedNegativesOption = negativesDropdown.selectedOptions[0];

  if (selectedNegativesOption && selectedNegativesOption.value !== 'none') {
    const negativesPrice =
      parseFloat(selectedNegativesOption.getAttribute('data-price')) / 100;
    total += negativesPrice;
  }

  // Update the displayed total price
  document.getElementById('totalPrice').textContent = '$' + total.toFixed(2);

  // Clear errors for fields that have been corrected
  renderErrors(validateForm().errors, { onlyExisting: true });
});

const form = document.getElementById('custom-form');

form.addEventListener('submit', function (event) {
  event.preventDefault(); // Prevent the default form submission

  const validation = validateForm();
  if (!validation.valid) {
    renderErrors(validation.errors);
    focusFirstInvalid(validation.errors);
    return;
  }
  renderErrors({});

  const formData = new FormData(form);
  const ids = formData.getAll('id[]');
  const quantities = formData.getAll('quantity[]');
  var totalQuantity = 0;

  const items = [];

  // Loop through each id and match it with its quantity
  for (let i = 0; i < ids.length; i++) {
    const id = ids[i];
    const quantity = parseFloat(quantities[i]);

    if (quantity > 0) {
      items.push({
        id: id,
        quantity: quantity,
      });

      totalQuantity += quantity;
    }
  }

  // add scans
  const scanDropdown = document.getElementById('scanDropdown');
  const selectedScanOption = scanDropdown.selectedOptions[0];
  const selectedVariant = document.querySelector(
    'input[name="selectedVariant"]:checked'
  );

  if (
    selectedScanOption &&
    selectedScanOption.value !== 'none' &&
    selectedScanOption.value !== 'process-only' &&
    totalQuantity > 0
  ) {
    let variantIdToAdd = null;

    if (selectedVariant) {
      // Multiple variants - use selected variant
      variantIdToAdd = selectedVariant.value;
    } else {
      // Single variant - get first variant from data
      const variantsData = selectedScanOption.getAttribute('data-variants');
      if (variantsData) {
        try {
          const variants = JSON.parse(variantsData);
          if (variants.length > 0) {
            variantIdToAdd = variants[0].id;
          }
        } catch (e) {
          console.error('Error parsing variants for cart:', e);
        }
      }
    }

    if (variantIdToAdd) {
      items.push({
        id: variantIdToAdd,
        quantity: totalQuantity, // totalQuantity represents the total number of films
      });
    }
  }

  // add prints
  const printsCheckbox = document.querySelector('input[name="prints_id"]');
  if (printsCheckbox.checked && totalQuantity > 0) {
    items.push({
      id: printsCheckbox.value,
      quantity: totalQuantity, // totalQuantity is the total number of films
    });
  }

  // add negative handling
  const selectedNegativesHandling =
    document.getElementById('negativesDropdown').value;
  if (selectedNegativesHandling !== 'none' && totalQuantity > 0) {
    items.push({
      id: selectedNegativesHandling,
      quantity: 1, // negatives only need handling once regardless of rolls
    });
  }

  // Add scanner choice to special instructions
  let scannerNotes = [];

  // Selected variant (scanner type)
  if (selectedVariant) {
    const variantLabel =
      selectedVariant.parentElement.querySelector('span').textContent;
    scannerNotes.push(`Scanner option: ${variantLabel}`);
  } else {
    // Single variant - get first variant name from data
    const scanDropdown = document.getElementById('scanDropdown');
    const selectedScanOption = scanDropdown.selectedOptions[0];
    if (
      selectedScanOption &&
      selectedScanOption.value !== 'none' &&
      selectedScanOption.value !== 'process-only'
    ) {
      const variantsData = selectedScanOption.getAttribute('data-variants');
      if (variantsData) {
        try {
          const variants = JSON.parse(variantsData);
          if (variants.length > 0) {
            scannerNotes.push(`Scanner option: ${variants[0].title}`);
          }
        } catch (e) {
          console.error('Error parsing variants for notes:', e);
        }
      }
    }
  }

  // Special instructions
  let specialInstructions = document
    .getElementById('specialInstructions')
    .value.trim();
  if (scannerNotes.length > 0) {
    const scannerInstructions = scannerNotes.join(', ');
    specialInstructions = specialInstructions
      ? `${scannerInstructions}\n${specialInstructions}`
      : scannerInstructions;
  }

  // Prepare payload for Shopify
  const payload = {
    items: items,
    note: specialInstructions,
  };

  // Make the AJAX request to add items to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (!response.ok)
        throw new Error('Shopify return an error, status: ' + response.status);
      return response.json();
    })
    .then((_data) => {
      // data.token was returning 'unknown' — rely on the cart cookie set by /cart/add.js
      window.location.href = `/checkout`;
    })
    .catch((error) => {
      console.error(error);
    });
});

// Show the next section based on input
function showNextSection(currentSection, nextSectionId) {
  const nextSection = document.getElementById(nextSectionId);
  if (currentSection) {
    nextSection.classList.add('active');
  } else {
    nextSection.classList.remove('active');
  }
}

// Populate scanner variants based on selected scan type
function populateScannerVariants(variants) {
  const scannerVariantsContainer = document.getElementById('scannerVariants');
  scannerVariantsContainer.innerHTML = '';

  if (!variants || variants.length === 0) return;

  variants.forEach((variant, index) => {
    const radioRow = document.createElement('div');
    radioRow.className = 'radioRow';

    const radioInput = document.createElement('input');
    radioInput.type = 'radio';
    radioInput.id = `scanner-variant-${variant.id}`;
    radioInput.name = 'selectedVariant';
    radioInput.value = variant.id;
    radioInput.setAttribute('data-price', variant.price);
    if (index === 0) radioInput.checked = true;

    const label = document.createElement('span');
    label.textContent = variant.title;

    radioRow.appendChild(radioInput);
    radioRow.appendChild(label);
    scannerVariantsContainer.appendChild(radioRow);

    radioInput.addEventListener('change', function () {
      document.querySelector('.custom-form').dispatchEvent(new Event('input'));
    });
  });
}

// For Film Types to Scans Section
document.querySelectorAll('input[name="quantity[]"]').forEach((input) => {
  input.addEventListener('input', function () {
    const anySelected = [
      ...document.querySelectorAll('input[name="quantity[]"]'),
    ].some((input) => parseFloat(input.value) > 0);
    showNextSection(anySelected, 'section2');
  });
});

// For Scans to Scanner Options Section
document.getElementById('scanDropdown').addEventListener('change', function () {
  const hasScans = this.value !== 'none' && this.value !== 'process-only';
  const selectedOption = this.selectedOptions[0];

  showNextSection(hasScans, 'sectionUpsells');
  showNextSection(this.value !== 'none', 'sectionNegatives');

  // Populate scanner variants if scans are selected
  if (hasScans && selectedOption) {
    const variantsData = selectedOption.getAttribute('data-variants');
    if (variantsData) {
      try {
        const variants = JSON.parse(variantsData);

        if (SCANNER_OPTION_ENABLED) {
          // Only show scanner options if there are multiple variants
          const showScannerOptions = variants.length > 1;
          showNextSection(showScannerOptions, 'sectionScannerOptions');

          populateScannerVariants(variants);

          // Trigger price calculation after variants are populated
          document
            .querySelector('.custom-form')
            .dispatchEvent(new Event('input'));
        }
      } catch (e) {
        console.error('Error parsing variants data:', e);
      }
    }
  } else {
    // Hide scanner options when no scans selected
    if (SCANNER_OPTION_ENABLED) {
      showNextSection(false, 'sectionScannerOptions');
    }

    // Trigger price calculation when scans are deselected
    document.querySelector('.custom-form').dispatchEvent(new Event('input'));
  }

  // Hide/show TIFF upsell based on scan type
  const tiffCheckbox = document.querySelector('input[name="tiff_id"]');
  const tiffOption = tiffCheckbox ? tiffCheckbox.closest('label') : null;

  if (selectedOption && tiffOption) {
    const scanType = selectedOption.getAttribute('data-scan-type') || '';
    const isLargeScan =
      scanType === 'film-processing-c-41-bw-high-resolution-scan';

    if (isLargeScan) {
      tiffOption.style.display = 'none';
      // Uncheck TIFF when switching to large scans
      tiffCheckbox.checked = false;
      console.log('TIFF unchecked - switched to large scan');
    } else {
      tiffOption.style.display = 'flex';
      console.log('TIFF shown - not a large scan');
    }

    // Trigger price recalculation after TIFF state change
    document.querySelector('.custom-form').dispatchEvent(new Event('input'));
  }
});

// For Negatives to Special Instructions Section
document
  .getElementById('negativesDropdown')
  .addEventListener('change', function () {
    const show = this.value !== 'none';
    showNextSection(show, 'sectionInstructions');

    const addToCartButton = document.getElementById('addToCartButton');
    if (show) {
      addToCartButton.classList.remove('hidden');
    } else {
      addToCartButton.classList.add('hidden');
    }
  });

// mobile tooltip
document.querySelectorAll('.info-icon').forEach((icon) => {
  icon.addEventListener('click', function () {
    const tooltipText = this.getAttribute('data-tooltip');
    const tooltipElem = document.createElement('div');
    tooltipElem.classList.add('mobile-tooltip');
    tooltipElem.innerText = tooltipText;

    // Toggle
    if (this.querySelector('.mobile-tooltip')) {
      this.removeChild(this.querySelector('.mobile-tooltip'));
    } else {
      this.appendChild(tooltipElem);
    }
  });
});
